import HeaderMinimal from '../../Shared/Headers/HeaderMinimal';
import React, { useContext, useEffect, useRef } from 'react';
import SideMenu from '../../Splitter/SideMenu/SideMenu';
import { star_icon } from '../../../utils/images';
import { ClientContext, ProfileContext } from '../../Contexts/contexts';
import ExpertReview from './ExpertReview';
import PlatformReview from './PlatformReview';
import Services from '../../Services/services';
import useToast from '../../Toasts/useToast';
import {
  ToastHeaders,
  ToastThemes,
  ToastMessages,
} from '../../Toasts/ToastOptions/toastOptions';
import useAuth from '../../Contexts/useAuth';

function Reviews() {
  const profileContext = useContext(ProfileContext);
  const clientContext = useContext(ClientContext);
  const ref = useRef(true);
  const enqueueToast = useToast();
  const { checkAuth, validateRoleRoute } = useAuth();

  useEffect(() => {
    const firstRendering = ref.current;

    if (checkAuth()) {
      if (validateRoleRoute('client')) {
        if (firstRendering) {
          ref.current = false;
          clientContext?.refreshClientExpertRelations();
        }
      }
    }
  }, [checkAuth, validateRoleRoute, clientContext]);

  function getAppointmentForQuote() {
    const searchAppointment = clientContext?.appointments.filter(
      (item) =>
        item?.clientExpertRelationshipId ===
          clientContext?.clientExpertRelation?.id &&
        item?.acceptedByClient === true &&
        item?.acceptedByExpert === true
    );

    return searchAppointment.length > 0 ? searchAppointment[0] : null;
  }

  const createExpertReview = async (
    review,
    selectedStrengths,
    cbSuccess = undefined
  ) => {
    try {
      const clientReview =
        await Services.clientReviewService.createExpertReview(review);

      const promises = [];
      selectedStrengths.forEach((strength) => {
        promises.push(
          Services.clientReviewService.createReviewStrengths(
            strength,
            clientReview.id
          )
        );
      });

      await Promise.all(promises);

      await Services.ratingService.updateRatingByIDAddRating(
        clientContext?.clientExpertRelation?.expert?.ratingId,
        { rating: review.rating }
      );

      if (cbSuccess !== undefined) cbSuccess();
    } catch (error) {
      console.error(error);
      enqueueToast(ToastMessages.ERROR_OCCURED_FETCH, {
        theme: ToastThemes.toastThemes.ERROR_OCCURED,
        header: ToastHeaders[ToastThemes.toastThemes.ERROR_OCCURED],
        duration: 3000,
      });
    }
  };

  async function deleteExpertReview(reviewId, cbSucess) {
    try {
      await Services.clientReviewService.deleteExpertReview(reviewId);

      await Services.ratingService.updateRatingByIDRemoveRating(
        clientContext?.clientExpertRelation?.expert?.ratingId,
        { rating: clientContext?.reviewExpert?.rating }
      );

      cbSucess();
    } catch (error) {
      console.error(error);
      enqueueToast(ToastMessages.ERROR_OCCURED_FETCH, {
        theme: ToastThemes.toastThemes.ERROR_OCCURED,
        header: ToastHeaders[ToastThemes.toastThemes.ERROR_OCCURED],
        duration: 3000,
      });
    }
  }

  const createPlatformReview = async (review, cbSuccess) => {
    try {
      await Services.clientReviewService.createPlatformReview(review);
      cbSuccess();
    } catch (error) {
      console.error(error);
      enqueueToast(ToastMessages.ERROR_OCCURED_FETCH, {
        theme: ToastThemes.toastThemes.ERROR_OCCURED,
        header: ToastHeaders[ToastThemes.toastThemes.ERROR_OCCURED],
        duration: 3000,
      });
    }
  };

  async function deletePlatformReview(reviewId, cbSuccess) {
    try {
      await Services.clientReviewService.deletePlatformReview(reviewId);
      cbSuccess();
    } catch (error) {
      console.error(error);
      enqueueToast(ToastMessages.ERROR_OCCURED_FETCH, {
        theme: ToastThemes.toastThemes.ERROR_OCCURED,
        header: ToastHeaders[ToastThemes.toastThemes.ERROR_OCCURED],
        duration: 3000,
      });
    }
  }

  return (
    <>
      <HeaderMinimal />
      {profileContext.isClient && (
        <>
          <div className="ts-container">
            <SideMenu />
            <div className="ts-container-column">
              <div className="ts-details-container">
                <div className="ts-details">
                  <div className="ts-title">Donner mon avis</div>
                  <div className="ts-resume">
                    Votre opinion revêt une grande importance pour nous et joue
                    un rôle vital au sein de la communauté d'entrepreneurs qui
                    utilisent CEC.
                    <br />
                    Contribuez à l'enrichissement collectif en partageant des
                    avis constructifs sur l'expert avec lequel vous avez
                    collaboré via CEC.
                  </div>
                </div>
                <div className="ts-number">
                  <div className="ts-number-container">
                    <div className="ts-number-title">Donnez votre avis</div>
                    <div className="ts-number-current"></div>
                  </div>
                  <img
                    className="ts-icon"
                    src={star_icon}
                    alt="star icon"
                  ></img>
                  <div className="green-rod"></div>
                </div>
              </div>
              <div className="reviews-container">
                {clientContext?.clientExpertRelation !== undefined &&
                  clientContext?.clientExpertRelation?.status >= 3 && (
                    <ExpertReview
                      appointment={getAppointmentForQuote(
                        clientContext?.clientExpertRelation
                      )}
                      createExpertReview={createExpertReview}
                      deleteReview={deleteExpertReview}
                    />
                  )}
                <PlatformReview
                  createPlatformReview={createPlatformReview}
                  deleteReview={deletePlatformReview}
                />
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default Reviews;
